import countrylist from './country'
import citylist from './city'
import asnlist from './ASN'
import devicelist from './DeviceData'

export default{
    state: {
        country: countrylist,
        devices: devicelist,
        city: citylist,
        asn: asnlist,
        usage: {},
        alert: false
    },
    getters: {
        country: (state) => state.country,
        countryWithCode: (state) => {
            var country = []
            state.country.map(res => {
                if (res) {
                    country.push({
                        "Country": res.Country,
                        "Country Name": "[" + res.Country + "] " + res["Country Name"],
                        "City": res.City,
                        "Parameter Value": res["Parameter Value"]
                    })
                }
            })

            return country
        },
        devices:(state) => state.devices,
        city:(state) => state.city,
        asn:(state) => state.asn,
        usageCredit: (state) => state.usage,
        alert: (state) => state.alert
    },
    mutations:{
        getUsage:(state, value) => {
            state.usage = value
        },
        copy: (state, value) => state.alert = value,
    }
}